import type React from 'react';

export interface InfoItemProps {
  label: string;
  value: React.ReactNode | string;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => (
  <div className="grid grid-cols-2 items-center min-h-[40px] gap-4">
    <div className="flex">
      <p className="text-[#5E6B7C] text-sm">{label}</p>
    </div>
    <div
      title={typeof value === 'string' ? value : undefined}
      className="flex text-[#010D1D] font-semibold overflow-clip"
    >
      {value}
    </div>
  </div>
);

export default InfoItem;
